import { BaseDocumentJSON } from './BaseDocuments'
import { Config } from './Documents'
import { BaseInvoiceDocument, LABELS } from './DocumentsInvoiceBase'
import { OcrRespItem, getHighlights } from './v2'

interface OcrRespHeaderBase {
  invoiceDate: OcrRespItem
  invliceDateN: string
  invoiceNo: OcrRespItem
  invoiceTitle: OcrRespItem
  totalAmountTaxIn: OcrRespItem
  totalAmountTaxEx: OcrRespItem
  totalTax: OcrRespItem
  taxInfo: OcrRespItem
  totalPrice8: OcrRespItem
  totalPrice10: OcrRespItem
  totalPrice: OcrRespItem
  subTotalPrice8: OcrRespItem
  subTotalPrice10: OcrRespItem
  subTotalPrice: OcrRespItem
  taxAmount8: OcrRespItem
  tasAmount10: OcrRespItem
  taxAmount: OcrRespItem
  taxAmountInfo: OcrRespItem
  carryoverAmount: OcrRespItem
  lastBilledAmount: OcrRespItem
  depositAmount: OcrRespItem
  discount: OcrRespItem
  withholdingTax: OcrRespItem
  etcAmount: OcrRespItem
  closingDate: OcrRespItem
  closingDateN: string
  otherDate: OcrRespItem
  otherDateN: string
  paymentDueDate: OcrRespItem
  paymentDueDateN: string
  currency: OcrRespItem
  orderNoOfSlip: OcrRespItem
  countryCode: string
}

interface OcrRespHeaderBillFrom {
  billFromCompanyName: OcrRespItem
  billFromCompanyId: OcrRespItem
  billFromDepartment: OcrRespItem
  billFromManagerName: OcrRespItem
  billFromPersonName: OcrRespItem
  billFromPostalCode: OcrRespItem
  billFromPostalCodeN: string
  billFromAddress: OcrRespItem
  billFromEmail: OcrRespItem
  billFromTel: OcrRespItem
  billFromFax: OcrRespItem
  billFromUrl: OcrRespItem
  // vendorCode, billFromAddressCode, custom1~20
}

interface OcrRespHeaderBillTo {
  billToCompanyName: OcrRespItem
  billToDept: OcrRespItem
  billToPerson: OcrRespItem
  billToPostalCode: OcrRespItem
  billToAddress: OcrRespItem
  billToTel: OcrRespItem
  billToFax: OcrRespItem
}

interface OcrRespHeaderBank {
  bankName: OcrRespItem
  bankCode: OcrRespItem
  bankBranchName: OcrRespItem
  bankBranchCode: OcrRespItem
  bankSwiftCode: OcrRespItem
  bankAccountHolder: OcrRespItem
  bankAccountType: OcrRespItem
  bankAccountCode: OcrRespItem
}

interface OcrRespHeaderContact {
  department: OcrRespItem
  personName: OcrRespItem
  postalCode: OcrRespItem
  address: OcrRespItem
  email: OcrRespItem
  tel: OcrRespItem
  fax: OcrRespItem
  homepage: OcrRespItem
}

interface OcrRespOther {
  note: OcrRespItem
}

interface OcrRespItemLine {
  id: string
  order: number
  itemNo: number
  itemName: OcrRespItem
  itemUnitPriceTaxIn: OcrRespItem
  itemUnitPrice: OcrRespItem
  itemQuantity: OcrRespItem
  itemUnitOfQuantity: OcrRespItem
  itemAmountTaxIn: OcrRespItem
  itemAmountTaxEx: OcrRespItem
  itemTax: OcrRespItem
  itemTaxType: OcrRespItem
  itemTaxTypeN: string
  itemDiscount: OcrRespItem
  itemCurrency: OcrRespItem
  itemDate: OcrRespItem
  itemDateN: string
  itemOrderNo: string
  itemEtc: OcrRespItem
}

interface OcrResp {
  headerBase: OcrRespHeaderBase
  headerBillFrom: OcrRespHeaderBillFrom
  headerBillTo: OcrRespHeaderBillTo
  headerBank: OcrRespHeaderBank
  headerContact: OcrRespHeaderContact
  other: OcrRespOther
  itemLines: OcrRespItemLine[] | null
}

interface InvoiceHeaderBase {
  invoiceDate: string
  invoiceDateN: string
  invoiceNo: string
  invoiceTitle: string
  totalAmountTaxIn: number
  totalAmountTaxEx: number
  totalTax: number
  totalInfo: string
  totalPrice8: number
  totalPrice10: number
  totalPrice: number
  subTotalPrice8: number
  subTotalPrice10: number
  subTotalPrice: number
  taxAmount8: number
  taxAmount10: number
  taxAmount: number
  taxAmountInfo: string
  lastBilledAmount: number
  depositAmount: number
  discount: number
  withholdingTax: number
  etcAmount: number
  closingDate: string
  closingDateN: string
  otherDate: string
  otherDateN: string
  paymentDueDate: string
  paymentDueDateN: string
  currency: string
  orderNoOfSlip: unknown
  countryCode: string
}

interface InvoiceHeaderBillFrom {
  billFromCompanyName: string
  billFromCompanyId: string
  billFromDepartment: string
  billFromManagerName: string
  billFromPersonName: string
  billFromPostalCode: string
  billFromAddress: string
  billFromEmail: string
  billFromTel: string
  billFromFax: string
  billFromUrl: string
  vendorCode: string
  billFromAddressCode: string
  custom1: string
  custom2: string
  custom3: string
  custom4: string
  custom5: string
  custom6: string
  custom7: string
  custom8: string
  custom9: string
  custom10: string
  custom11: string
  custom12: string
  custom13: string
  custom14: string
  custom15: string
  custom16: string
  custom17: string
  custom18: string
  custom19: string
  custom20: string
}

interface InvoiceHeaderBillTo {
  billToCompanyName: string
  billToDept: string
  billToPerson: string
  billToPostalCode: string
  billToAddress: string
  billToTel: string
  billToFax: string
}

interface InvoiceHeaderBank {
  bankName: string
  bankCode: string
  bankBranchName: string
  bankBranchCode: string
  bankSwiftCode: string
  bankAccountHolder: string
  bankAccountType: string
  bankAccountCode: string
}

interface InvoiceHeaderContact {
  department: string
  personName: string
  postalCode: string
  address: string
  email: string
  tel: string
  fax: string
  homepage: string
}

interface InvoiceOther {
  note: string
}

export type InvoiceItemLine = {
  id: string
  order: number
  itemName: string
  expenseTypeCode: string
  expenseTypeCodeDumb: string
  itemUnitPriceTaxIn: number
  itemUnitPrice: number
  itemQuantity: number
  itemUnitOfQuantity: number
  itemAmountTaxIn: number
  itemAmountTaxEx: number
  itemTax: number
  itemTaxType: string
  itemDiscount: number
  itemCurrency: string
  itemDate: string
  itemDateN: string
  itemOrderNo: number
  itemEtc: string
  expenseTypeRuleId?: string
}

interface OcrEditResult {
  headerBase: InvoiceHeaderBase
  headerBillFrom: InvoiceHeaderBillFrom
  headerBillTo: InvoiceHeaderBillTo
  headerBank: InvoiceHeaderBank
  headerContact: InvoiceHeaderContact
  other: InvoiceOther
  // TODO: confirm null
  itemLines: InvoiceItemLine[] | null
}

interface InvoiceV2Config {
  headerBase: Config
  headerBillFrom: Config
  headerBillTo: Config
  headerBank: Config
  headerContact: Config
  other: Config
  itemLines: Config
}

export type DocumentInvoiceV2JSON = BaseDocumentJSON & {
  ocrResp: OcrResp
  ocrEditResult: OcrEditResult
  config: InvoiceV2Config
}

export const BASE_SECTIONS = [
  'headerBase',
  'headerBillFrom',
  'headerBillTo',
  'headerBank',
  'headerContact',
  'other',
] as (keyof OcrResp)[]

export const OCR_RESP_INVOICE_KEYS = [
  ...BASE_SECTIONS,
  'itemLines',
] as (keyof OcrResp)[]

export class DocumentInvoiceV2 extends BaseInvoiceDocument {
  constructor(public docJSON: DocumentInvoiceV2JSON) {
    super(docJSON)
  }

  protected fixDates(newEdit: { [x: string]: any }) {
    // datepicker sets Date type
    newEdit.headerBase.invoiceDate = this.date2str(
      newEdit.headerBase.invoiceDate,
    )
    // WONT'T FIX dateN timezone?
    // newEdit.headerBase.invoiceDateN = iDate.toISOString()
    newEdit.headerBase.paymentDueDate = this.date2str(
      newEdit.headerBase.paymentDueDate,
    )
    newEdit.headerBase.closingDate = this.date2str(
      newEdit.headerBase.closingDate,
    )
    newEdit.headerBase.otherDate = this.date2str(newEdit.headerBase.otherDate)
    newEdit.itemLines = newEdit.itemLines?.map((l) => ({
      ...l,
      itemDate: this.date2str(l.itemDate),
    }))
  }

  getHighlights() {
    return getHighlights(BASE_SECTIONS, LABELS, this.docJSON)
  }
}
